import constants, {
    ACCESS_TOKEN,
    HTTP_METHODS
} from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
const jwtToken = localStorage.getItem(ACCESS_TOKEN);

return {
"Content-Type": "application/json",
"Authorization": `Bearer ${jwtToken}`
    };
}

function connect(data) {
return axiosClient({
url: constants.api.source.connect,
method: HTTP_METHODS.POST,
headers: _constructHeader(),
data: data
    });
}

function createBranch(data) {
return axiosClient({
url: constants.api.source.branch,
method: HTTP_METHODS.POST,
headers: _constructHeader(),
data: data
    });
}

function switchBranch(data) {
return axiosClient({
url: constants.api.source.switchBranch,
method: HTTP_METHODS.POST,
headers: _constructHeader(),
data: data
    });
}

function syncCode(data) {
return axiosClient({
url: constants.api.source.sync,
method: HTTP_METHODS.POST,
headers: _constructHeader(),
data: data
    });
}

function getProjectSCMMapping(projectId) {
return axiosClient({
url: constants.api.source.getMapping,
method: HTTP_METHODS.GET,
headers: _constructHeader(),
params: {
projectId: projectId
        }
        
    });
}


async function fetchBranches(projectId) {
    try {
        const response = await axiosClient({
            url: constants.api.source.fetch,
            method: HTTP_METHODS.POST,
            headers: _constructHeader(),
            params: {
                projectId: projectId
            }
        });

        console.log("Fetch branches success:", response);
        return response;
    } catch (error) {
        console.error("Fetch branches failed:", {
            status: error?.response?.status,
            responseData: error?.response?.data,
            requestUrl: error?.config?.url,
            message: error?.message
        });

        throw error;
    }
}




const SCMService = {
connect,
createBranch,
switchBranch,
syncCode,
getProjectSCMMapping,
fetchBranches
};

export default SCMService;